import _memoize from 'lodash/memoize';
import _snakeCase from 'lodash/snakeCase';
import _isObject from 'lodash/isObject';

export interface IMessageSource {
	[key: string]: string | IMessageSource;
}

const resolvers: {[key: string]: () => Promise<IMessageSource>} = {
	en: () => import('./en'),
	ru: () => import('./ru'),
};

export const AVAILABLE_LOCALES: Record<string, string> = (
	Object.keys(resolvers)
		.reduce((result, locale) => ({
			...result,
			[_snakeCase(locale).toUpperCase()]: locale
		}), {})
);

export const DEFAULT_LOCALE = AVAILABLE_LOCALES.EN || 'en';

function _getMessagesForLocale(source?: IMessageSource, parent?: string) {
	source = source || {};

	return Object.entries(source).reduce(((result, [key, message]) => {
		const path = [parent, key].filter(Boolean).join('.');

		if (_isObject(message)) {
			return {...result, ..._getMessagesForLocale(message, path)};
		}

		return {...result, [path]: message};
	}), {});
}

export const getMessagesForLocale: (locale: string) => Promise<{[key: string]: string}> = _memoize((locale: string) => {
	return (
		(resolvers[locale] || resolvers[DEFAULT_LOCALE] || (() => Promise.resolve({})))()
			.then(source => {
				return _getMessagesForLocale(source);
			})
	);
}, (...args) => args[0]);
